// ** Logo
import logo from '@src/assets/images/logo/logo.png'

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner vh-100 d-flex justify-content-center'>
      <div className='d-flex justify-content-center'>
        <img className='fallback-logo' src={logo} alt='logo' height='50' />
      </div>
      <div className='loading d-flex justify-content-center'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
